import { makeStyles, Theme } from '@material-ui/core/styles';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';
import { calculateHeight, calculateWidth } from 'src/common/helpers/dimension-helper';
interface Prop {
  maxWidth: number;
  height: number;
  fullScreen: boolean;
  minWidth?: number;
}
export const styles = makeStyles<Theme, Prop>(() => ({
  dialogPaper: {
    borderRadius: 2,
    minHeight: '47.8vh',
    maxHeight: ({ fullScreen }) => (fullScreen ? '100%' : ''),
    width: ({ fullScreen }) => (fullScreen ? '100%' : ''),
    margin: ({ fullScreen }) => (fullScreen ? 0 : ''),
    height: ({ height }) => `${height}vh`,
    maxWidth: ({ maxWidth }) => `${maxWidth}vw`,

    '@media (aspect-ratio: 4/3)': {
      minWidth: ({ minWidth }) => `${minWidth}vw`,
      minHeight: '51.43vh',
    },
  },
  warningPaperFullWidth: {
    maxWidth: '58.56vw',
  },
  closeButton: {
    width: 'auto',
    marginBottom: 20,
    marginRight: 10,
    fontSize: rem(1),
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  acceptButton: {
    marginBottom: 20,
    marginRight: 20,
    fontSize: rem(1),
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  dialogContainerMain: {
    backgroundColor: themeColor.lightBackground,
    flex: '1 1 0',
    textAlign: 'center',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: themeColor.lightBackground,
  },
  dialogItemContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem 0rem 0rem 1.25rem',
  },
  dialogSeparateButtonContent: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1rem 0rem 0rem 1rem',
  },
  dialogCancelItemContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '1rem 0rem 0rem 1.25rem',
  },
  dialogContainerButtonsMain: {
    padding: `0 ${calculateWidth(20).stringValue} ${calculateHeight(20).stringValue} ${
      calculateWidth(20).stringValue
    }`,
    columnGap: calculateWidth(10).stringValue,
    background: themeColor.lightBackground,
  },
  dialogContainerButtons: {
    columnGap: calculateWidth(10).stringValue,
    minHeight: calculateHeight(30).stringValue,
  },
}));
